import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { apiRequest } from "@/api/client";
import artegoIcon from "@/assets/artego-icon.png";

// Pagina pubblica aperta dal link d'invito: l'auditor sceglie la password (minimo 10 caratteri) e poi accetta i documenti privacy.
export default function AuditorInvite() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", password: "", again: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    apiRequest(`/auditor/invite/${encodeURIComponent(token)}`).then((d) => { setInfo(d); setForm((f) => ({ ...f, name: d.name || "" })); }).catch((e) => setError(e.message));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 10) { setError("La password deve avere almeno 10 caratteri."); return; }
    if (form.password !== form.again) { setError("Le due password non coincidono."); return; }
    setBusy(true); setError("");
    try {
      const d = await apiRequest("/auditor/invite/accept", { method: "POST", body: JSON.stringify({ token, password: form.password, name: form.name }) });
      localStorage.setItem("dvr_token", d.token);
      window.location.assign("/auditor/");
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 px-4" data-testid="auditor-invite">
      <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl border bg-white p-6 shadow-sm">
        <div className="flex items-center gap-3"><img src={artegoIcon} alt="" className="h-10 w-10 rounded-md" /><h1 className="font-heading text-2xl font-bold">Invito come auditor</h1></div>
        {error && <p className="rounded bg-rose-50 p-3 text-sm text-rose-800" role="alert">{error}</p>}
        {info && (
          <>
            <p className="text-sm text-slate-700">Account per <b>{info.email}</b>. L'invito scade il {new Date(info.expires_at).toLocaleString("it-IT")}.</p>
            <label className="block text-sm font-medium">Nome e cognome<input className="mt-1 h-12 w-full rounded-lg border-2 border-slate-300 px-3" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></label>
            <label className="block text-sm font-medium">Scegli la password (almeno 10 caratteri)<input type="password" autoComplete="new-password" className="mt-1 h-12 w-full rounded-lg border-2 border-slate-300 px-3" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required /></label>
            <label className="block text-sm font-medium">Ripeti la password<input type="password" autoComplete="new-password" className="mt-1 h-12 w-full rounded-lg border-2 border-slate-300 px-3" value={form.again} onChange={(e) => setForm({ ...form, again: e.target.value })} required /></label>
            <Button className="h-14 w-full text-lg" disabled={busy} data-testid="invite-submit">Crea l'account</Button>
            <p className="text-xs text-slate-600">Al prossimo passo leggerai e accetterai informativa privacy e atto di nomina a responsabile del trattamento.</p>
          </>
        )}
      </form>
    </div>
  );
}
